<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">vip续费</a></li>
            </ul>
        </div>
        
        <div class="formbody">    
            <div class="jian">&nbsp;</div>
            <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>温馨提示：</b>
            </div>    
            <ul class="infolist">
                <li><span>1.充值前询问客服短信内容是否可以发再决定要不要充值</span></li> 
                <li><span>2.预付款属用户自愿存入，只能用于云验证平台内消费，不能退款</span></li> 
                <li><span><b class="ea2020">充值前请确认您已经理解并将遵守本系统的</b><a href="#">资费表/套餐最低消费规则、用户协议</a></span></li>
            </ul> 

            <div id="usual1" class="usual">     
                <div class="itab">
                    <ul> 
                        <li><a href="#tab1" class="selected">支付宝VIP续费</a></li> 
                    </ul>
                </div>     
  	            <div id="tab1" class="tabson">    
                    <ul class="forminfo">
                        <li v-if="chargeActivityState==1"><label></label><font style="font-size:20px;" color="red">二办最新充值送活动：单笔充值满{{minChargeMoney}}以上 比划账优惠加送{{addRate}}%,直接充值到短信账户</font></li>           
                        <li><label>订单号<b>*</b></label><input name="" v-model="bidKey" type="text" disabled="true" class="dfinput" value=""  style="width:518px;"/></li>
                        <li><label>充值门牌号<b>*</b></label><input name="" type="text" class="dfinput" disabled="true" value="" v-model="account"  style="width:518px;"/></li>
                        <li><label>充值金额<b>*</b></label><input name="" type="text" class="dfinput" disabled="true" v-model="chargeMoney"  style="width:468px;"/><i>元</i></li>
                        <li><label class="tdlast" >有效期至：</label><span class="lh33">{{expiredtime}} </span></li>
                        <li><label>&nbsp;</label>
                            <a :href="payUrl"><img src="../../assets/images/alipay_bwrx.gif" ></a>
                        </li>
                        <!-- <li><label>&nbsp;</label><input class="sure1" type="button" value="提交支付宝或网上银行支付" @click="paySubmit()">&nbsp;</li> -->
                    </ul>    
                </div>
            </div>
    
            <!-- <div class="tip tip1 ">
                <div class="tiptop"><span>云验证-支付宝支付信息确认</span><a></a></div>   
                <ul class="forminfo">    
                    <li><label class="tdlast" >订单号：</label><span class="lh33">{{bidKey}}</span> </li>                    
                    <li><label class="tdlast" >充值门牌号：</label><span class="lh33">{{account}}</span></li>                   
                    <li><label class="tdlast" >本次充值金额：</label><span class="lh33">{{chargeMoney}} </span></li>                    
                    <li><label class="tdlast" >有效期至：</label><span class="lh33">{{expiredtime}} </span></li>
                    <li><label>&nbsp;</label>
                        <a :href="payUrl" target="_blank" ><img src="../../assets/images/alipay_bwrx.gif" ></a>
                    </li>
                </ul>        
            </div> -->

        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            grade:1,
            expiredtime:'',
            account:'',
            money:0,
            chargeLineList:[],
            userCouponList:[],
            couponList:[],
            bidKey:'',
            chargeMoney:0,
            num:'1',
            userCouponId:0,
            description:'无抵用券！',
            couponMoney:0,
            allMoney:0,
            payUrl:'',
            chargeActivityState:0,
            minChargeMoney:0,
            addRate:0,
            invoicetype:0,
            numList:[{value:1,label:1},{value:2,label:2},{value:3,label:3},{value:4,label:4},{value:5,label:5},
                    {value:6,label:6},{value:7,label:7},{value:8,label:8},{value:9,label:9},{value:10,label:10}],
            btnShow:false,
        }
    },
    mounted(){
        // this.grade = this.$route.query.grade;
        // this.expiredtime = this.$route.query.expiredtime;
        // this.account = this.$route.query.account;
      this.getData();
    //   console.log('this.$route.query',this.$route.query)  
    //   console.log(this.grade, this.expiredtime);
    //   this.chargeMoney = parseInt(this.grade) * 120;
    },
    computed:{
    //   _num: {
    //     set: function(value) {
    //         this.num = value;
    //     },
    //     get: function() {
    //         return this.num.replace(/[^0-9]+/g,'')
    //     }
    //   }
    },
    methods:{
      getData(){
        var that = this
        let param = {}
        this.$ajax({
            method: 'post',
            url: this.GLOBAL.serverSrc + "/person/vippay.json",
            data: param,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'token' : this.GLOBAL.token
            }
        }).then(function(res) {
            console.log('res.data',res.data);
            if(res.data.code == '0000000')
            {
                that.bidKey = res.data.bidKey;
                that.account = res.data.account;
                that.chargeMoney = res.data.chargeMoney;
                that.payUrl = res.data.payUrl;
                that.expiredtime = res.data.expiredTime;
            }
            else
            {
                alert(res.data.msg)
                return false;
            }
        })
      },
      paySubmit(){
        let that = this;
        let data = {'bidKey':this.bidKey,'money':this.money,'chargeMoney':this.chargeMoney,'num':this.num,'userCouponId':this.userCouponId}
        this.$ajax({
              method: 'post',
              url: this.GLOBAL.serverSrc + "/person/aliyaysubmit.json",
              data: data,
              headers: {
                  'Content-Type': 'application/json; charset=UTF-8',
                  'token' : this.GLOBAL.token
              }
          }).then(function(res) {
              if(res.data.code == '0000000')
              {
                  that.allMoney = res.data.allMoney;
                  that.couponMoney = res.data.couponMoney;
                  that.payUrl = res.data.payUrl;
                  that.showSubmit();
              }
              else
              {
                  alert(res.data.msg);
                  return false;
              }
          })
      },
      showSubmit(){
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
      },
      onRadioChange(id, description){
          this.userCouponId = id;
          this.description = description;
      },
      onSelectChange(){
        let that = this;
        let num = 0;
        this.userCouponList.forEach(function(obj,index){
            if(obj.chargeMoney <= that.chargeMoney*that.num)
            {
                that.userCouponId = obj.id;
                that.description = obj.description;
                num = 1;
            }
        });
        if(0 == num)
        {
            this.userCouponId = 0;
            this.description = "无抵用券";
        }
      },
      getCoupon(id){
          let that = this;
        let data = {'id':id}
        this.$ajax({
              method: 'post',
              url: this.GLOBAL.serverSrc + "/person/getcoupon.json",
              data: data,
              headers: {
                  'Content-Type': 'application/json; charset=UTF-8',
                  'token' : this.GLOBAL.token
              }
          }).then(function(res) {
              if(res.data.code == '0000000')
              {
                  that.userCouponList = res.data.userCouponList;
                  that.couponList = res.data.couponList;
              }
              else
              {
                  alert(res.data.msg);
                  return false;
              }
          })
      }
    }
}
</script>
<style>
.title_top1{color: red;font-size: 14px;margin:0px 2px 0px 2px;}
.el-icon-plus:hover{color: rgb(68, 139, 233);}
.el-icon-plus{width:260px;cursor: pointer;font-size:13px;letter-spacing:2px;}
.top_button{letter-spacing:2px;}
.el-radio__input{top:-10px;}
.div-a{ float:left;width:49%;border:1px solid #F00} 
.div-b{ float:left;width:49%;border:1px solid #000} 

.coupon-wrapper{width:100%; height:auto; padding:0 0 2px 0;clear:both;overflow: hidden;}
        .coupon-wrapper .coupon-item{width: 100%;}
        .coupon-wrapper h3{ height: 3rem; line-height: 1.8rem;font-size: 1.4rem; color:#454545; padding: 2% 0;}
        .coupon-item .nick{padding:.66% 0; color: #fff;}
        .coupon-item .coupon-money {width: 100%; display: -webkit-box; display: -webkit-flex; display: flex; font-size: 1.2rem; align-items: center;}
        .coupon-item .coupon-money em{font-size: 3.8rem;}
        .coupon-item .coupon-money .lay:last-child{flex: 1; padding:0 3%;line-height: 1.66rem;}

        .style-four{width: 250px; height:8rem; position: relative;
         display: -webkit-box; display: -webkit-flex; display: flex; align-items: center; justify-content: center;
         background-color: #fff; border:1px solid #E5004F; float: left;}
        .style-four .info-box{-webkit-box: 1; -webkit-flex: 1; flex: 1; padding: 0 1% 0 10%; position: relative;}

        .style-four .get-btn{
            display: -webkit-box; display: -webkit-flex; display: flex; align-items: center; justify-content: center;
            width: 24%; height: 8rem; text-align: center; color: #fff; font-size: 1.5rem; line-height: 1.35; background-color: #E5004F; position: relative;}

        .style-four .nick{color: #000;font-weight: bold;font-size: 16px;}
        .style-four .of, .style-four .lay .tit,
        .style-six .nick{color: #E5004F;font-weight: bold;font-size: 24px;}
        .style-four .lay .demand{color:#000;font-weight: bold;font-size: 18px;}
        .style-four .lay .demand2{color:#000;font-size: 12px;}

        .style-four{background-color: #fff; -webkit-border-radius:1rem; border-radius: 1rem;border: 1px dashed #e5004f;}
        .style-four .get-btn{background-color: #E5004F;width: 30%; height: 8rem; color: #fff; text-align: center;border-top-right-radius: 1rem;border-bottom-right-radius: 1rem;}
        .style-four .get-btn span{ display: block; padding:2.66rem 0; font-size: 1.5rem; word-break: break-all; color: #fff;;}


        /* 已领取 */
        .style-four.have .of, .style-four.have .tit, .style-four.have .demand{color: #c1c1c1;}
        .style-four.have .get-btn span{color: #767676; font-size: 1.6rem;}
        .style-four.have{border: 1px dashed #C1C1C1;}
</style>


// WEBPACK FOOTER //
// src/components/person/vipcharge.vue